// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__vB6c2","path":"Breadcrumbs_path__1m1PV","delimiter":"Breadcrumbs_delimiter__Kh3bd","delimiterIcon":"Breadcrumbs_delimiterIcon__G947a"};